var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServicePageLayout',{attrs:{"title":"Alert","subtitle":"ประวัติการแจ้งเตือน","icon":"mdi-alert-outline","breadcrumb":"Operations"}},[_c('v-card',{staticClass:"service-content-panel",attrs:{"flat":""}},[_c('v-card-text',[_c('ALERT_DATATABLE')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }